import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DomainsModel, Domain } from './../../models/domains.model';

@Component({
  selector: 'app-modal-domain',
  templateUrl: './modal-domain.component.html',
  styles: []
})

export class ModalDomainComponent implements OnInit{

  domain : Domain;
  formControl = new FormControl('');
  modalForm : FormGroup;
  server: string;
  private _domainsModel = new DomainsModel;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) { }

  ngOnInit(){
      this.modalForm = this.fb.group({
        clave: [this.domain ? this.domain.clave : null],
        nombre: [this.domain ? this.domain.nombre : null],
        url: [this.domain ? this.domain.url : null],
        usuario: [this.domain ? this.domain.usuario : null],
        password: [this.domain ? this.domain.password : null],
        tipo: [this.domain ? this.domain.tipo : null],
        contacto_nombre: [this.domain ? this.domain.contactoNombre : null],
        phpVersion : [this.domain ? this.domain.phpVersion : null],
        tema: [this.domain ? this.domain.tema : null],
        wpVersion: [this.domain ? this.domain.wpVersion : null],
        plugins: [this.domain ? this.domain.plugins : null],
        observaciones: [this.domain ? this.domain.observaciones : null],
        servidor_nombre: [this.domain ? this.domain.servidorNombre : null],
      });
  }

  adminDomain(){
    this.activeModal.close('Guardado datos');
    this._domainsModel.createDomain(this.modalForm.value, this.server);
  }

}
